<template>
  <div id="usuarios">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-widget title="CATÁLOGO DE USUARIOS" color="primary darken-4" dark>
            <div slot="widget-content">
              <v-layout wrap class="container">
                <v-flex xs12 sm6>
                  <v-btn
                    color="success"
                    dark
                    fab
                    small
                    slot="activator"
                    @click="abrirDialogNuevoUsuario"
                  >
                    <v-icon dark>add</v-icon>
                  </v-btn>
                </v-flex>

                <form-usuario
                  :usuario="usuarioSeleccionado"
                  ref="dialogUsuario"
                  @onUsuarioAdded="onUsuarioAdded"
                  @onUsuarioUpdated="onUsuarioUpdated"
                ></form-usuario>
              </v-layout>

              <v-layout row wrap>
                <v-flex lg12>
                  <v-card>
                    <v-toolbar card color="white">
                      <v-text-field
                        flat
                        solo
                        prepend-icon="search"
                        placeholder="Búsqueda rápida"
                        v-model="search"
                        hide-details
                        class="hidden-sm-and-down"
                      ></v-text-field>
                      <v-btn icon>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                      <v-data-table
                        :headers="usuarios.headers"
                        :search="search"
                        :items="usuarios.data"
                        :rows-per-page-items="[
                          10,
                          25,
                          50,
                          { text: 'Todos', value: -1 },
                        ]"
                        class="elevation-1"
                        item-key="usuarioId"
                      >
                        <template slot="items" slot-scope="props">
                          <td>
                            <v-avatar size="48">
                              <v-icon color="green" medium>account_box</v-icon>
                            </v-avatar>
                          </td>
                          <td>{{ props.item.aliasUsuario }}</td>
                          <td>{{ props.item.nombreCompleto }}</td>
                          <td>{{ props.item.email }}</td>
                          <td>{{ props.item.telefono }}</td>
                          <td>{{ props.item.sexo }}</td>
                          <td>{{ props.item.nombreRol }}</td>
                          <td>
                            <v-btn
                              depressed
                              outline
                              icon
                              fab
                              dark
                              color="primary"
                              small
                              @click="getUsuario(props.item.usuarioId)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <v-btn
                              depressed
                              outline
                              icon
                              fab
                              dark
                              color="pink"
                              small
                              @click="deleteUsuario(props.item.usuarioId)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </td>
                        </template>
                        <v-alert
                          slot="no-results"
                          :value="true"
                          color="error"
                          icon="warning"
                          outline
                          >La búsqueda para "{{ search }}" no encontró
                          registros</v-alert
                        >
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-container>

    <confirm ref="confirm"></confirm>

    <snack-bar></snack-bar>

    <loading-alert></loading-alert>
  </div>
</template>

<script>
//Global components
import VWidget from "@/components/VWidget";
import confirm from "@/components/dialogs/Confirm";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

//Internal components
import formUsuario from "./FormUsuario";

//Services
import usuarioService from "@/services/usuarioService";

export default {
  components: {
    VWidget,
    confirm,
    loadingAlert,
    snackBar,
    formUsuario,
  },
  data() {
    return {
      search: "",
      usuarios: {
        headers: [
          { text: "", align: "center", sortable: false },
          { text: "ALIAS", align: "center", value: "aliasUsuario" },
          { text: "NOMBRE COMPLETO", align: "center", value: "nombreCompleto" },
          { text: "CORREO", align: "center", value: "email" },
          { text: "TELÉFONO", align: "center", value: "telefono" },
          { text: "SEXO", align: "center", value: "sexo" },
          { text: "ROL", align: "center", value: "nombreRol" },
          { text: "ACCIONES", value: "acciones", align: "right" },
        ],
        data: [],
      },
      usuarioSeleccionado: {
        usuarioId: "",
        aliasUsuario: "",
        password: "",
        nombreCompleto: "",
        email: "",
        telefono: "",
        sexo: "",
        usuarioRolId: 0,
        pinAccesoPublico:"",
        privilegiosJson: "",
        privilegiosUsuario: {
          iniciarSesion: true,
          usuarioAgregar: false,
          usuarioModificar: false,
          usuarioEliminar: false,
          usuarioConsultar: false,
          usuariosConsultar: false,
          sucursalesConsultar: false,
          sucursalConsultar: false,
          sucursalAgregar: false,
          sucursalModificar: false,
          sucursalEliminar: false,

          sucursalesConsultar: false,
          sucursalConsultar: false,
          sucursalAgregar: false,
          sucursalModificar: false,
          sucursalEliminar: false,

          //Rentas
          rentaAgregar: false,
          rentaModificar: false,
          rentaCancelar: false,
          rentaEliminar: false,
          rentaConsultar: false,
          rentaAgregarBitacora: false,
          rentaConsultarBitacora: false,
          rentaConsultarPagos: false,
          rentaAgregarPagos: false,
          rentaModificarPagos: false,
          rentaEliminarPagos: false,
          rentasConsultar: false,
          rentasCorte: false,
          rentaGenerarTicket: false,

          //VENTAS
          ventaAgregar: false,
          ventaModificar: false,
          ventaEliminar: false,
          ventaConsultar: false,
          ventaGenerarTicket: false,
          ventasConsultar: false,
          ventasCorte: false,

          //PRODUCTOS
          productoAgregar: false,
          productoModificar: false,
          productoEliminar: false,
          productoConsultar: false,
          productosConsultar: false,
          productosFotosAgregar: false,
          productosFotosEliminar: false,
          productosFotosModificar: false,
          productosFotosConsultar: false,

          //CATALOGO PRODUCTOS
          catalogoProductoAgregar: false,
          catalogoProductoModificar: false,
          catalogoProductoEliminar: false,
          catalogoProductoConsultar: false,

          //PRECIOS PRODUCTO
          preciosProductoConsulta: false,
          preciosProductoModificar: false,

          //INVENTARIO PRODUCTO
          inventarioProductoAgregar: false,
          inventarioProductoModificar: false,
          inventarioProductoConsulta: false,

          //DISPONIBILIDAD
          disponibilidadConsulta: false,

          //CONJUNTOS
          conjuntoAgregar: false,
          conjuntoModificar: false,
          conjuntoEliminar: false,
          conjuntoConsultar: false,
          conjuntosConsultar: false,
          conjuntoProductoAgregar: false,
          conjuntoProductoEliminar: false,

          //CLIENTES
          clienteAgregar: false,
          clienteModificar: false,
          clienteEliminar: false,
          clienteConsultar: false,
          clientesConsultar: false,

          //PARAMETROS EMPRESA
          parametrosEmpresaModificar: false,
          parametrosEmpresaConsultar: false,

          //OTROS CATÁLOGOS - Colores producto
          colorProductoAgregar: false,
          colorProductoModificar: false,
          colorProductoEliminar: false,
          colorProductoConsultar: false,
          coloresProductosConsultar: false,

          //OTROS CATÁLOGOS - Líneas producto
          lineaProductoAgregar: false,
          lineaProductoModificar: false,
          lineaProductoEliminar: false,
          lineaProductoConsultar: false,
          lineasProductoConsultar: false,

          //OTROS CATÁLOGOS - Marcas producto
          marcaProductoAgregar: false,
          marcaProductoModificar: false,
          marcaProductoEliminar: false,
          marcaProductoConsultar: false,
          marcasProductoConsultar: false,

          //OTROS CATÁLOGOS - Marcas producto
          tallaProductoAgregar: false,
          tallaProductoModificar: false,
          tallaProductoEliminar: false,
          tallaProductoConsultar: false,
          tallasProductoConsultar: false,

          //OTROS CATÁLOGOS - Tipos Producto
          tipoProductoAgregar: false,
          tipoProductoModificar: false,
          tipoProductoEliminar: false,
          tipoProductoConsultar: false,
          tiposProductoConsultar: false,
        },
        sucursalesUsuario: [],
      },
    };
  },
  mounted() {
    this.getUsuarios();
  },
  methods: {
    getUsuarios() {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      usuarioService
        .getAllForGrid()
        .then((result) => {
          self.usuarios.data = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    abrirDialogNuevoUsuario() {
      this.$store.state.tituloForm = "AGREGAR USUARIO";
      this.$store.state.iconoForm = "/images/general/agregar-40.png";
      this.$refs.dialogUsuario.resetForm();
      this.$refs.dialogUsuario.openDialog();
    },
    getUsuario(usuarioId) {
      let self = this;

      self.$store.state.loadingInfo.show = true;

      usuarioService
        .getById(usuarioId)
        .then((result) => {
          self.$store.state.tituloForm = "MODIFICAR USUARIO";
          self.$store.state.iconoForm = "/images/general/actualizar-40.png";
          self.$refs.dialogUsuario.resetForm();
          self.usuarioSeleccionado = result;
          self.$refs.dialogUsuario.openDialog();
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    deleteUsuario() {},
    onUsuarioAdded(usuario) {
      this.usuarios.data.push(usuario);
    },
    onUsuarioUpdated(usuario) {
      var i = this.usuarios.data.findIndex(
        (obj) => obj.usuarioId == usuario.usuarioId
      );
      this.usuarios.data.splice(i, 1, usuario);
    },
  },
};
</script>
